import React, { ReactElement } from 'react';
import { Typography } from '../../Typography/Typography';
import styles from '../Table.module.scss';
import { TTableVariant } from '../types';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export enum ScopeType {
  row = 'row',
  col = 'col',
}

export interface ITableHeaderCellProps {
  header: string;
  scope: ScopeType;
  colWidth?: number;
  rowHeight?: TTableVariant;
}

const TableHeaderCell = ({ header, scope, colWidth, rowHeight = 'regular' }: ITableHeaderCellProps): ReactElement => (
  <th
    className={cx('cell', { 'cell-compact': rowHeight === 'compact' })}
    style={{ width: `${colWidth}%` }}
    scope={scope}
  >
    <Typography size={rowHeight === 'compact' ? 'M' : 'L'} transform="uppercase-first-letter" weight="semi-bold">
      {header}
    </Typography>
  </th>
);

export default TableHeaderCell;
